import { useEffect, useState } from 'react';

const Polygon: React.FC<google.maps.PolygonOptions> = (options) => {
  const [polygon, setPolygon] = useState<google.maps.Polygon>();

  useEffect(() => {
    if (!polygon) {
      setPolygon(new google.maps.Polygon());
    }

    // remove polygon from map on unmount
    return () => {
      if (polygon) {
        polygon.setMap(null);
      }
    };
  }, [polygon]);

  useEffect(() => {
    if (polygon) {
      polygon.setOptions(options);
    }
  }, [options, polygon]);

  return null;
};

export default Polygon;
